$(document).ready(function () {
    // Init select2.
    $('.js-select2-init').select2();

    // Show deleted rows button
    $('.js-show-delete').change(function () {
        $('#'+$(this).attr('data-table-id')).DataTable().ajax.reload();
    })

    // Change file label
    $('.js-change-file-label').change(function (e) {
        let fileName = e.target.files[0].name;
        $('#fileInputLabel').text(fileName);
    });
});


// Global delete
function deleteItem(url, element) {
    deleteAccept().then((result) => {
        if (result.value) {
            $.ajax({
                url: url,
                type: "POST",
                data: {
                    '_method': 'delete',
                    '_token': $("meta[name='csrf-token']").attr("content")
                },
                success: function (result) {
                    if(result.good_msg)
                        showJsSuccessToast(result.good_msg);
                    else
                        showJsDangerToast(result.bad_msg);
                    $(element).closest('table').DataTable().ajax.reload()
                },
            });
        }
    });
}
window.deleteItem = deleteItem;

// Global restore
function restoreItem(url, element) {
    $.ajax({
        url: url,
        type: "POST",
        data: {
            '_token': $("meta[name='csrf-token']").attr("content")
        },
        success: function (result) {
            showJsSuccessToast(result.good_msg);
            $(element).closest('table').DataTable().ajax.reload()
        },
    });
}
window.restoreItem = restoreItem;
